







































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Button types
import { ButtonType } from './types';

@Component
export default class Button extends Vue {

    @Prop({ type: String, required: true })
    private title!: string;

    @Prop({ type: String })
    private width!: string;

    @Prop({ type: Boolean })
    private large!: boolean;

    @Prop({ type: Boolean })
    private fullWidth!: boolean;

    @Prop({
        type: String,
        validator(type: ButtonType): boolean {

            return Object.values(ButtonType).includes(type);

        },
    })
    private type!: string;

    @Prop({ type: Boolean })
    private disabled!: boolean;

    @Prop({ type: Boolean })
    private loading!: boolean;

    /**
     *  Used to get the class for the forwarded type.
     */
    private get typeClass(): string | null {

        return this.type ? `ccos-button--${ this.type }` : null;

    }

    /**
     *  Used to only emit the click event if the
     *  button isn't disabled.
     */
    private click(event: PointerEvent): void {

        if (this.disabled || this.loading) {

            return;

        }

        this.$emit('click', event);

    }

}
